import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionFunnelChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No conversion funnel data available
      </div>
    );
  }

  const maxUsers = data?.[0]?.users || 1;

  return (
    <div className="space-y-4">
      {data?.map((stage, index) => {
        const widthPercentage = (stage?.users / maxUsers) * 100;
        const isLastStage = index === data?.length - 1;

        return (
          <div key={stage?.stage} className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="font-medium text-foreground">{stage?.stage}</span>
                {stage?.dropOff > 0 && (
                  <span className="text-xs text-error flex items-center gap-1">
                    <Icon name="TrendingDown" size={12} />
                    {stage?.dropOff}% drop-off
                  </span>
                )}
              </div>
              <div className="flex items-center gap-3">
                <span className="text-muted-foreground">{stage?.users?.toLocaleString()} users</span>
                <span className="font-semibold text-primary">{stage?.percentage}%</span>
              </div>
            </div>
            <div className="relative h-12 bg-muted/30 rounded-lg overflow-hidden">
              <div
                className={`h-full flex items-center justify-center transition-all duration-500 ${
                  isLastStage ? 'bg-success' : 'bg-primary'
                }`}
                style={{ width: `${widthPercentage}%` }}
              >
                {widthPercentage > 15 && (
                  <span className="text-xs font-medium text-white">
                    {stage?.percentage}%
                  </span>
                )}
              </div>
            </div>
            {index < data?.length - 1 && (
              <div className="flex justify-center">
                <Icon name="ChevronDown" size={16} className="text-muted-foreground" />
              </div>
            )}
          </div>
        );
      })}

      {/* Summary Stats */}
      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Total Entered</p>
            <p className="text-lg font-bold text-foreground">{data?.[0]?.users?.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Converted</p>
            <p className="text-lg font-bold text-success">{data?.[data?.length - 1]?.users?.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Overall Rate</p>
            <p className="text-lg font-bold text-primary">{data?.[data?.length - 1]?.percentage}%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionFunnelChart;